module.exports = __webpack_public_path__ + "img/audio_off_button.da04e00a.svg";